import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactEditComponent } from '../contact-edit/contact-edit.component';
import { ContactDeleteComponent } from '../contact-delete/contact-delete.component';
import { ContactListAssignComponent, ContactCustomField } from '../contact-list-assign/contact-list-assign.component';
import { Title } from '@angular/platform-browser';
import { Contact } from '../contact/contact.model';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { Location } from '@angular/common';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';
declare var $: any;

@Component({
  selector: 'contact-search',
  templateUrl: './contact-search.component.html',
  styleUrls: ['./contact-search.component.css']
})

export class ContactSearchComponent implements OnInit {
  @ViewChild('editModal', { static: false }) editModal: ContactEditComponent;
  @ViewChild('deleteDialog', { static: false }) deleteDialog: ContactDeleteComponent;
  @ViewChild('assignForm', { static: false }) assignForm: ContactListAssignComponent;

  private contacts: Contact[] = [];
  private dataTable: any;
  private dtTable: any;
  private checked: any[] = [];
  private navbarHeadline: any;
  private searchStr: string;
  private selectedCompany: number;
  private subs = new SubSink();

  constructor(private repository: HttpRepositoryService, private titleService: Title,
    private router: Router, private activeRoute: ActivatedRoute,
    private location: Location,
    private companyService: UserCompanyService) { }


  ngOnInit(): void {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.dataTable = $('#contactTable');
    this.navbarHeadline = $('#navbarHeadline');

    this.subs.sink = this.activeRoute.params.subscribe(resp => {
      this.searchStr = this.activeRoute.snapshot.paramMap.get('search');

      this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
        this.selectedCompany = cmpResp;
        this.loadData();
      });
    });
  }

  private loadData() {
    this.navbarHeadline.html(' Search Contacts');

    if (this.searchStr != '') {

      this.subs.sink = this.repository.get<Contact[]>('api/Contact/Search?query=' + this.searchStr + '&companyId=' + this.selectedCompany).pipe(map(x => x.data))
        .subscribe(resp => {
          this.contacts = resp;
          this.createDataTable();
        });
    }
  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.contacts,
      columns: [
        {
          name: 'id',
          visible: false

        },
        {
          name: 'email',
          width: '250px'
        },
        {
          name: 'phone',
          width: '150px'
        },
        {
          name: 'isEmailConfirmed',
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'isActive',
          class: 'text-center',
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          boolTrueDisplay: 'Active',
          boolFalseDisplay: 'Inactive'

        },
        {
          name: 'insAt',
          width: '100px'
        },
        {
          name: 'contactLists',
          width: '300px'
        }
      ],
      orderBy: [[0, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        }]
      },
      buttons: [{
        text: '<i class="fas fa-arrow-left"></i>',
        class: '',
        action: function () {
          that.goBack()
        }
      },
      {
        text: '<i class="far fa-check-square"></i>',
        class: '',
        action: function () {
          that.assign()
        }
      }]
    };

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);

  }

  private edit(id) {
    var contact = this.contacts.find(x => x.id === id);

    if (contact) {
      this.subs.sink = this.repository.get<Contact>('api/Contact/Details/' + contact.id + '?companyId=' + this.selectedCompany).pipe(map(x => x.data))
        .subscribe(data => {
          this.editModal.show(data, false, this.selectedCompany);
        });
    }
  }

  private goBack() {
    this.location.back();
  }

  private onSaved(data: Contact) {
    var contact = this.contacts.find(x => x.id === data.id);

    if (contact) {
      contact.email = data.email;
      contact.phone = data.phone;
    } else {
      data.isActive = true;
      this.contacts.push(data);
    }

    this.createDataTable();
  }

  private onAssigned(data: ContactCustomField[]) {
    this.loadData();
  }

  private onUnsubscribed(data: Contact) {
    this.loadData();
  }

  private assign() {
    this.checked = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => ({ id: x.id, email: x.email, phone: x.phone, isActive: x.isActive }))

    if (this.checked.length == 0) {
      this.deleteDialog.show("You must select contact!", MessageType.OK, null, "Assign conformation!"); //only for displaying msg
    } else {
      this.assignForm.show(this.checked, this.selectedCompany);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
